export default __webpack_public_path__ + "static/media/road_to_success.4dc3f89b.png";